import { z } from 'zod';

const coordinatesSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const commentSchema = z.object({
  id: z.number(),
  map: z.number(),
  content: z.string(),
  coordinates: coordinatesSchema,
  deleted: z.boolean(),
  visible: z.boolean(),
  authorId: z.number().nullable().optional(),
  email: z.string().nullable().optional(),
  removeReason: z.string().nullable().optional(),
});
